import type { RouteInformation } from "@/components/navigation/Navigation"
import { faTableList } from "@fortawesome/free-solid-svg-icons"

export const AppRoutes: Record<string, RouteInformation> = {
	"/": {
		name: "Marriage Claim Search",
		icon: faTableList,
	},
}
